const $circleGroup = $('.background-circleGroup');
const $circle1 = $(`.-circle1`, $circleGroup);
const $circle2 = $(`.-circle2`, $circleGroup);

const data = [
    { size: 1080, x: 1440 / 2 - 461, y: (77 - 43) / 2, rotate: 0 },
    { size: 1080, x: 1440 / 2 - 846, y: (59 - 61) / 2, rotate: 0 },
    { size: 1080, x: 1440 / 2 - 590, y: (639 - 441) / 2, rotate: 90 },
    { size: 791, x: 0, y: 0, rotate: -30 },
    { size: 1080, x: 1440 / 2 - 617, y: (67 - 53) / 2, rotate: 0 },
    { size: 791, x: -395, y: 235, rotate: 90 },
    { size: 1080, x: -289, y: 33, rotate: 0 },
    { size: 1080, x: 1, y: 33, rotate: 0 },
    { size: 791, x: 0, y: 90, rotate: 30 },
    { size: 1080, x: -388, y: 35, rotate: 0 },
]

export const update = (scene) => {
    const _size = data[scene].size;
    const _x = data[scene].x;
    const _y = data[scene].y;
    const _rotate = data[scene].rotate;

    const size = _size;
    const scaleRatio = size / 960;
    const ww = window.innerWidth;
    const wh = window.innerHeight;
    const baseWidth = size;
    const baseHeight = size;
    const scaleX = ww / baseWidth;
    const scaleY = wh / baseHeight;
    // const scale = Math.min(scaleX, scaleY * scaleRatio);
    const scale = ww / 1440;
    const width = Math.ceil(baseWidth * scale);
    const height = Math.ceil(baseHeight * scale);
    $circle1.css('width', `${width}px`);
    $circle1.css('height', `${height}px`);
    $circle2.css('width', `${width}px`);
    $circle2.css('height', `${height}px`);

    const topCenter = `${(wh - height)/ 2}px`
    const offsetX = _x;
    const offsetXRatio = offsetX / 1440 * 100;
    const offsetY = _y;
    const offsetYRatio = offsetY / 960 * 100;

    $circle1.css('left', `50%`);
    $circle2.css('left', `calc(50% - ${width}px)`);
    $circle1.css('top', `${topCenter}`);
    $circle2.css('top', `${topCenter}`);
    $circleGroup.css(
        'transform', `translate(${offsetXRatio}%, ${offsetYRatio}%) rotate(${_rotate}deg) `
    );
}